export class CalendarIntegrationService {
  public showButton: boolean;
  public isDisabled: boolean;
  public callMethod: () => void;

  constructor() {
    this.showButton = false;
    this.isDisabled = false;
    this.callMethod = () => false;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/services/calendar_integration_service.ts